import React, { useRef, useState, useEffect, useCallback } from 'react';

// Folha A4 a 96dpi — a mesma largura do editor, do PDF e do link público.
export const PAGE_W = 794;
export const PAGE_H = 1123;

/**
 * Renderiza o conteúdo na largura real da folha e escala para caber na caixa.
 * Assim a prévia é fiel ao documento: nada reflui nem quebra diferente.
 * `maxHeight` limita a altura (miniatura); sem ele, ajusta só pela largura, no
 * máximo 1:1.
 */
export default function EscalaDocumento({ children, maxHeight }) {
  const boxRef = useRef(null);
  const contentRef = useRef(null);
  const [geo, setGeo] = useState({ scale: 1, height: 0, offsetX: 0 });

  const medir = useCallback(() => {
    const box = boxRef.current;
    const content = contentRef.current;
    if (!box || !content) return;
    const largura = box.clientWidth;
    if (!largura) return;
    let scale = Math.min(1, largura / PAGE_W);
    if (maxHeight) scale = Math.min(scale, maxHeight / PAGE_H);
    setGeo({
      scale,
      height: content.offsetHeight * scale,
      offsetX: Math.max(0, (largura - PAGE_W * scale) / 2)
    });
  }, [maxHeight]);

  useEffect(() => {
    medir();
    const observer = new ResizeObserver(medir);
    if (boxRef.current) observer.observe(boxRef.current);
    if (contentRef.current) observer.observe(contentRef.current);
    window.addEventListener('resize', medir);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', medir);
    };
  }, [medir]);

  return (
    <div ref={boxRef} className="relative w-full overflow-hidden" style={{ height: geo.height }}>
      <div
        ref={contentRef}
        className="absolute top-0"
        style={{ width: PAGE_W, left: geo.offsetX, transform: `scale(${geo.scale})`, transformOrigin: 'top left' }}
      >
        {children}
      </div>
    </div>
  );
}
